import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const LonelinessStyles = styled(OnboardingPage)`
  .title {
    margin: 20px auto;
  }
`;
